import { render } from "./ContactUs.vue?vue&type=template&id=06f9eca3&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=06f9eca3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06f9eca3"

export default script